import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Customize your primary color
    },
    secondary: {
      main: '#dc004e', // Customize your secondary color
    },
  },
  typography: {
    h4: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          marginTop: '64px', // Adjust based on the height of your NavBar
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          padding: '16px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          marginBottom: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9',
          },
          '&:hover': {
            backgroundColor: '#e0e0e0 !important',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          '&:hover': {
            boxShadow: 6, // Apply emboss effect on hover
          },
        },
      },
    },
  },
});

export default theme;